import { useState, useEffect } from 'react'
import { supabase } from '../../shared/lib/supabase'

/** Read the user's profession from their preferences. */
export function useProfession(): string | null {
  const [profession, setProfession] = useState<string | null>(null)

  useEffect(() => {
    async function load() {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) return

      const { data } = await supabase
        .from('users')
        .select('preferences')
        .eq('id', user.id)
        .single()

      if (data?.preferences) {
        const prefs = data.preferences as Record<string, unknown>
        setProfession((prefs.profession as string) ?? null)
      }
    }
    load()
  }, [])

  return profession
}
